import { useEffect } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import { useSubNav } from "./contexts/SubNavContext";
import './Layout.css';

export default function Layout() {
    const { subNav } = useSubNav();
    const location = useLocation();
    const isMainPage = location.pathname === '/preview';

    useEffect(() => {
        // body 클래스 관리
        if (subNav) {
            document.body.classList.remove('main-page');
        } else {
            document.body.classList.add('main-page');
        }
    }, [subNav]);

    return (
        <>
            <header className={isMainPage ? "index" : ""}>
                <div className="wrap_cont">
                    <div className="header_cont">
                        <h1>
                            <Link to="/preview"><img src="/resources/img/ync_logo.png" alt="로고" /></Link>
                        </h1>
                        <nav>
                            <ul>
                                <li><Link to="/sub_company">회사소개</Link></li>
                                <li><Link to="/sub_people">피플</Link></li>
                                <li><Link to="/sub_business">사업영역</Link></li>
                                <li><Link to="/sub_recruit">인재채용</Link></li>
                                <li><Link to="/sub_contact">오시는길</Link></li>
                            </ul>
                        </nav>
                    </div>
                </div>
                
                {/* 서브 페이지 네비게이션 */}
                {subNav && (
                    <div className="nav_sub" id="navSub">
                        <ul>
                            {subNav.map((item, index) => (
                                <li key={index} className={item.active ? 'on' : ''}>
                                    <a 
                                        href={item.href || '#'} 
                                        onClick={(e) => {
                                            if (item.onClick) {
                                                item.onClick(e);
                                            } else {
                                                e.preventDefault();
                                                const targetId = item.href?.replace('#', '');
                                                if (targetId) {
                                                    const element = document.getElementById(targetId);
                                                    if (element) {
                                                        element.scrollIntoView({ behavior: 'smooth' });
                                                    }
                                                }
                                            }
                                        }}
                                    >
                                        {item.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </header>

            <Outlet />

            <footer id="footer">
                <div className="footer_cont">
                    <div className="footer_logo">
                        <a href="#"><img src="/resources/img/footer_logo.jpg" alt="ync 하단 로고" /></a>
                    </div>
                    <div className="footer_text">
                        <div className="footer_adress">
                            <p>서울특별시 강남구 봉은사로20길 41 와이앤씨빌딩</p>
                        </div>
                        <div className="footer_info">
                            <p>
                                사업자등록번호 : 144-81-05037&nbsp;&nbsp;|&nbsp;&nbsp;대표자 : 윤석중&nbsp;&nbsp;
                                COPYRIGHT&copy; 2016 BY YNCSMARTAPPS ALL RIGHT RESERVED
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}
